import { Component, Input } from '@angular/core';

@Component({
  selector: 'achoo-pie-chart-placholder',
  templateUrl: './achoo-pie-chart-placholder.component.html',
  styleUrls: ['./achoo-pie-chart-placholder.component.scss']
})
export class AchooPieChartPlacholderComponent {
  @Input() title: string;
  @Input() list: string[];
  @Input() messageTitle: string;
  @Input() messageContent: string;
  constructor() { }
}



// WEBPACK FOOTER //
// ./src/app/core/achoo-pie-chart-placholder/achoo-pie-chart-placholder.component.ts